import { Notifications } from "./Notifications.tsx";

export const notifications = () => [
  {
    target: "$ONE_TOOLBAR_CONTENT_RIGHT",
    handler: {
      component: Notifications,
    },
  },
];
